import { useEffect, useState } from 'react'
import {
	Grid,
	GridItem,
	FormControl,
	Input,
	Select,
	Button,
} from '@chakra-ui/react'
import { FiSearch } from 'react-icons/fi'
import { getRequest } from '../services/base.service'
import { fetchBusinessList } from '../redux'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { objectToQueryParams } from '../helpers/utils'
import Autocomplete from "react-google-autocomplete";

const HomeSearchForm = () => {
	const [countries, setCountries] = useState([])
	const [states, setStates] = useState([])
	const [cities, setCities] = useState([])
	const [selectedData, setSelectedData] = useState({
		'miles': 25
	})

	const dispatch = useDispatch()
	const navigate = useNavigate()

	useEffect(() => {
		// fetchCountries()
	}, [])

	const handleOnChange = (name, value) => {
		if (name === 'country') {
			if (!value) {
				setStates([])
				setCities([])
				return
			}
			fetchState(value)
		} else if (name === 'state') {
			if (!value) {
				setCities([])
				return
			}
			fetchCities(value)
		}
		setSelectedData({ ...selectedData, [name]: value })
	}

	const fetchCountries = () => {
		getRequest('countries')
			.then((res) => {
				setCountries(res.result)
			})
			.catch((err) => {
				console.error(err)
			})
	}

	const fetchState = (countryId) => {
		getRequest(`states/${countryId}`)
			.then((res) => {
				setStates(res.result?.states || [])
				setCities(res.result?.cities || [])
			})
			.catch((err) => {
				console.error(err)
			})
	}

	const fetchCities = (stateId) => {
		getRequest(`cities/${stateId}`)
			.then((res) => {
				setCities(res.result?.cities || [])
			})
			.catch((err) => {
				console.error(err)
			})
	}

	const handleSubmitSearchForm = (e) => {
		e.preventDefault()
		dispatch(
			fetchBusinessList(selectedData,false, (isSuccess) => {
				if (isSuccess) navigate(`/search?${objectToQueryParams(selectedData)}`)
			})
		)
	}

	const autocompleteStyle = {
	    "borderRadius": "0.375rem",
	    "border": "1px solid",
	    "borderColor": "#718096",
	    "height": "3rem",
	    "width": "100%",
	    "padding": "0 1rem"
	}

	const autocompleteOptions = {
		fields: ["address_components", "geometry", "formatted_address"],
    	types: ["geocode"],
	    componentRestrictions: { country: ["us", "ca"] }
	}

	return (
		<Grid
			as={'form'}
			onSubmit={handleSubmitSearchForm}
			templateRows="repeat(2, 1fr)"
			templateColumns="repeat(4, 1fr)"
			gap={4}
		>
			<GridItem colSpan={3}>
				<FormControl>
					<Input
						id="keywords"
						type="text"
						onChange={(e) => handleOnChange('keyword', e.target.value)}
						onBlur={(e) => handleOnChange('keyword', e.target.value)}
						size={'lg'}
						borderColor={'gray.500'}
						placeholder="Business/Product/Product Category"
					/>
				</FormControl>
			</GridItem>


			<GridItem colSpan={[2, 2, 1, 1]}>
				<Select
					size={'lg'}
					value={selectedData?.miles}
					onChange={(e) => handleOnChange('miles', e.target.value)}
					borderColor={'gray.500'}
					placeholder={'Miles'}
				>
					<option key="1" value="25">25 miles</option>
					<option key="2" value="50">50 miles</option>
					<option key="3" value="100">100 miles</option>
					<option key="4" value="150">150 miles</option>
					<option key="5" value="200">200 miles</option>
					<option key="6" value="250">250 miles</option>
				</Select>
			</GridItem>

			<GridItem colSpan={[6, 6, 3, 3]}>
				<FormControl>
					<Autocomplete
					  apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
					  className="chakra-input"
					  style={autocompleteStyle}
					  options={autocompleteOptions}
					  placeholder={'City, State, Country or Postal Code'}
					  onChange={(e) => handleOnChange('address', e.target.value)}
					  onBlur={(e) => handleOnChange('address', e.target.value)}
					/>
				</FormControl>
			</GridItem>

			<GridItem colSpan={[4, 4, 1, 1]}>
				<Button
					size={'lg'}
					w={'full'}
					type={'submit'}
					bg={'brand.500'}
					color={'brand.50'}
					_hover={{
						bg: 'brand.600',
						color: 'white',
					}}
					_focus={{
						bg: 'brand.700',
						color: 'white',
					}}
					_active={{
						bg: 'brand.700',
						color: 'white',
					}}
					leftIcon={<FiSearch />}
				>
					Search
				</Button>
			</GridItem>

		</Grid>
	)
}

export default HomeSearchForm
